import { z } from 'zod';

const COMMENT_MAX_CHARS = 10000 as const;

const EntityType = z.enum(['user', 'file', 'owner', 'action']);

const OwnerEntity = z.object({
    type: z.literal('owner'),
    id: z.string().min(1),
    label: z.string().min(1),
});

const MentionEntity = z.object({
    type: z.literal('user'),
    id: z.string().min(1),
    label: z.string().min(1),
});

const FileEntity = z.object({
    type: z.literal('file'),
    id: z.string().min(1),
    label: z.string().min(1),
});

const ActionEntity = z.object({
    type: z.literal('action'),
    id: z.string().min(1),
    label: z.string().min(1),
});

export const Entity = z.discriminatedUnion('type', [
    OwnerEntity,
    MentionEntity,
    FileEntity,
    ActionEntity,
]);

const CommentContext = z.object({
    documentId: z.string().nullable().optional(),
});

export const CommentSubmitPayload = z.object({
    v: z.literal(1),
    message: z.string().min(1, 'Please enter a comment').max(COMMENT_MAX_CHARS),
    entities: z.array(Entity),
    context: CommentContext.optional(),
});

export type EntityType = z.infer<typeof EntityType>;
export type Entity = z.infer<typeof Entity>;
export type CommentSubmitPayload = z.infer<typeof CommentSubmitPayload>;

export interface Comment {
    id: number;
    message: string;
    createdAt: string;
    editedAt: string;
    link: string;
    author: CommentCollaborator;
    mentions: CommentCollaborator[];
    files: CommentFile[];
}

export interface CommentCollaborator {
    id: number;
    name: string;
    email: string;
    role?: string;
    avatar?: string;
}

export interface CommentFile {
    id: number;
    title: string;
}
